import $thousandMask from "@/mixins/thousandMask";
// import * as types from "@/store/types";
// import { mapGetters } from "vuex";
import truncate from "@/filters/truncate";

export default {
  name: "number-input",
  components: {},
  filters: { truncate },
  props: {
    maximumDeposit: {
      default: false,
      type: Boolean
    },
    maximumText: {
      type: String
      // default:
    },
    iso: {
      type: String,
      default: "IRR"
    },
    label: {
      type: String
    },
    maximum: {
      type: Boolean
    },
    errorStep: {
      type: Boolean
    },
    amountCurrency: {
      type: String
    },
    exponent: {
      type: Number,
      default: 3
    },
    availableAmount: {
      type: String
    }
  },
  mixins: [$thousandMask],
  data() {
    return {
      maxDepositAmount: "",
      amount: "",
      balanceAmount: "",
      currencyExponent: null
    };
  },
  computed: {
    // ...mapGetters({
    //   getWallets: types.operations.getters.GET_WALLET
    // }),
    // evaluateBalance() {
    //   if (Object.entries(this.getWallets).length > 0) {
    //     return this.getWallets.wallets.find(elem => {
    //       if (elem.currency.iso === this.iso) {
    //         this.currencyExponent = elem.exponent;
    //         return elem;
    //       }
    //     });
    //   }
    // }
  },
  mounted() {},
  watch: {
    amount(newValue, oldValue) {
      if (newValue && this.exponent !== null) {
        let newNumber = this.removeThousand(newValue);
        let numberLength = newNumber.toString().split(".")[1]
          ? newNumber.toString().split(".")[1].length
          : 0;

        const isPositiveNumbers = str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };

        const withoutDot = newValue.replace(".", "");

        if (numberLength && numberLength > this.exponent) {
          this.amount = oldValue;
        } else if (this.exponent === 0 && newValue.includes(".")) {
          this.amount = oldValue.replace(".", "");
        }

        if (newNumber[0] === "0") {
          if (newNumber[1] && newNumber[1] !== ".") {
            this.amount = "";
          }
        } else if (withoutDot.includes(".")) {
          this.amount = oldValue;
        } else if (!isPositiveNumbers(newValue)) {
          this.amount = oldValue;
        }
      }
    },
    maxDepositAmount(newValue, oldValue) {
      if (newValue && this.exponent !== null) {
        let newNumber = this.removeThousand(newValue);
        let numberLength = newNumber.toString().split(".")[1]
          ? newNumber.toString().split(".")[1].length
          : 0;
        const isPositiveNumbers = str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        const withoutDot = newValue.replace(".", "");
        if (numberLength && numberLength > this.exponent) {
          this.maxDepositAmount = oldValue;
        } else if (this.exponent === 0 && newValue.includes(".")) {
          this.maxDepositAmount = oldValue.replace(".", "");
        }
        if (newNumber[0] === "0") {
          if (newNumber[1] && newNumber[1] !== ".") {
            this.maxDepositAmount = "";
          }
        } else if (withoutDot.includes(".")) {
          this.maxDepositAmount = oldValue;
        } else if (!isPositiveNumbers(newValue)) {
          this.maxDepositAmount = oldValue;
        }
      }
    },
    // evaluateBalance: {
    //   immediate: true,
    //   handler(newValue) {
    //     if (newValue) {
    //       this.balanceAmount = this.maximum
    //         ? newValue.balance_string_format
    //         : "";
    //     }
    //   }
    // },
    amountCurrency: {
      immediate: true,
      handler(newValue) {
        if (newValue !== null) {
          this.amount = newValue;
        }
        this.$emit("changeAmountCurrency", null);
      }
    }
  },
  methods: {
    handleInput({ target: { value } }) {
      if (!this.maximumDeposit) {
        const set = amount => {
          let enDigits = this.toEnglishDigits(amount);
          let noComma = this.removeThousand(enDigits);
          let zeroLead = this.leadingZero(noComma);
          let amountMask = this.$thousandMask(zeroLead);
          this.amount = noComma ? amountMask : 0;
        };
        set(value);
        this.$emit("earnAmount", this.removeThousand(this.amount));
      } else {
        const set = amount => {
          let enDigits = this.toEnglishDigits(amount);
          let noComma = this.removeThousand(enDigits);
          let zeroLead = this.leadingZero(noComma);
          let amountMask = this.$thousandMask(zeroLead);
          this.maxDepositAmount = noComma ? amountMask : 0;
        };
        set(value);
        this.$emit("maxDeposit", this.removeThousand(this.maxDepositAmount));
      }
    },
    toEnglishDigits(value) {
      const persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return value
        .toString()
        .replace("٫", ".")
        .replace(/[۰-۹]/g, chr => {
          return persian.indexOf(chr);
        });
    },
    removeThousand(value) {
      const str = value.toString();
      return str.replace(/,/gi, "");
    },
    leadingZero(value) {
      let number = value.toString();
      if (value.includes(".")) {
        while (number.charAt(0) === "0" && number.charAt(1) !== ".") {
          number = number.substring(1);
        }
      } else if (number.slice(-1) !== "0") {
        while (number.charAt(0) === "0") {
          number = number.substring(1);
        }
      }
      return number;
    },
    addMaxDepositToInput() {
      this.maxDepositAmount = this.$thousandMask(this.availableAmount);
      this.$emit("maxDeposit", this.removeThousand(this.maxDepositAmount));
    },
    addBalanceToInput() {
      this.amount = this.$thousandMask(
        this.availableAmount ?? this.balanceAmount
      );
      this.$emit("earnAmount", this.removeThousand(this.amount));
    }
  }
};
